const PropTypes = require("prop-types");
const React = require("react");
const { formatText } = require("core/i18n").i18n;
const { EMAIL_REGEX } = require("constants/index");
const { InputSafe } = require("commonsComponents/inputSafe");

class BeneficiaryEmailNotification extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            email: props.email.get("value")
        };

        this.handleEmailBlur = this.handleEmailBlur.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
    }

    handleEmailBlur() {
        const email = this.state.email;
        const isValid = email === "" || EMAIL_REGEX.test(email);

        this.props.setEmailNotification(this.state.email, isValid);
    }

    handleEmailChange(evt) {
        this.setState({
            email: evt.target.value
        });
    }

    render() {
        const labelEmail = formatText("transferSummary-step2EmailLabel");
        const errorMessage = formatText("transferSummary-step1IncorrectEmail");
        let tooltipErrorMessage;

        if (!this.props.email.get("isValid")) {
            tooltipErrorMessage = errorMessage;
        }

        return (
            <div className="beneficiary-email-notification">
                <InputSafe
                    type="email"
                    label={labelEmail}
                    onBlur={this.handleEmailBlur}
                    onChange={this.handleEmailChange}
                    value={this.state.email}
                    errorState={!this.props.email.get("isValid")}
                    errorMessage={errorMessage}
                    title={tooltipErrorMessage}
                    name={"inp_emailAddress"}
                />
            </div>
        );
    }
}

BeneficiaryEmailNotification.propTypes = {
    email: PropTypes.object,
    setEmailNotification: PropTypes.func.isRequired
};

module.exports = BeneficiaryEmailNotification;
